

import { forwardRef, useContext } from 'react';

import { Text } from '../text/text';
import { TextButtonRootContext } from './context/text-button-root.context';
import { textButtonLabelRecipe } from './styles/text-button-label.styles';
import type { TextButtonLabelPropsInterface } from './types/text-button-label.types';

/**
 * @since 10.0.0
 */

export const TextButtonLabel = forwardRef<HTMLSpanElement, TextButtonLabelPropsInterface>(
  (props: TextButtonLabelPropsInterface, forwardedRef) => {
    const {
      tone = 'brand',
      disabled = false,
      onImpact = false,
      textStyle: contextTextStyle,
    } = useContext(TextButtonRootContext);
    const { children, css: cssProp, textStyle, ...rest } = props;

    return (
      <Text
        ref={forwardedRef}
        data-c11n-component="TextButton.Label"
        data-c11n-version={__C11N_VERSION__}
        textStyle={textStyle || contextTextStyle}
        css={{
          ...textButtonLabelRecipe.raw({ tone, disabled, onImpact }),
          ...cssProp,
        }}
        {...rest}
      >
        {children}
      </Text>
    );
  },
);

TextButtonLabel.displayName = 'TextButton.Label';
